export default __webpack_public_path__ + "../staticImages/strand_rose-260.png";